import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react'
import { useEffect } from 'react'

export default function Contact() {
  useEffect(() => {
    document.title = 'Contact - KALARAVA'
  }, [])

  const facultyCoordinators = [
    { name: 'Prof. Akshata Pethe', dept: 'Faculty Coordinator', phone: '+91 9900742147', email: 'petheakshata94@gmail.com', image: '/coordinators/Prof.-Akshata-Pethe-2024.jpg' },
    { name: 'Prof. Annapoorna Hiremath', dept: 'Faculty Coordinator', phone: '+91 7349164388', email: 'ashiremath1234@gmail.com', image: '/coordinators/Annapoorna-Hiremath.jpg' },
    { name: 'Prof. Akshay Hiremath', dept: 'Faculty Coordinator', phone: '+91 9731448778', email: 'hiremathakshay22@gmail.com', image: '/coordinators/Prof.-Akshay-Hiremath-2024.jpg' },
    { name: 'Prof. Malikjan N Bagawan', dept: 'Faculty Coordinator', phone: '+91 7204349740', image: '/coordinators/Prof.-Malikjan-N-Bagawan-2024.jpg' },
  ]

  const studentVolunteers = [
    { name: 'Ganesh Nandi', role: 'Web Architect/Tech Head', phone: '+91 8884077319', image: '/coordinators/ganesh.jpg' },
    { name: 'Pratham Kyasti', role: 'Marketing/Design Head', phone: '+91 7411326304', image: '/coordinators/pratham.jpg' },
    { name: 'Guruprasad Pujari', role: 'Gaming Head', phone: '+91 6366796357', image: '/coordinators/guruprasad.jpg' },
    { name: 'VigyanPuri Goswami', role: 'Finance Head', phone: '+91 8217788016', image: '/coordinators/vigyan.jpg' },
    { name: 'Ramesh Totagi', role: 'Hospitality Head', phone: '+91 9164701983', image: '/coordinators/ramesh.jpg' },
    { name: 'Vikas Kolavi', role: 'Logestic Head', phone: '+91 8618954549', image: '/coordinators/vikas.jpg' },
  ]

  return (
    <>
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16 animate-fade-up">
            <div className="inline-block mb-4">
              <h1 className="text-5xl md:text-6xl font-black bg-gradient-to-r from-kala-blue via-kala-cyan to-kala-orange bg-clip-text text-transparent mb-4">
                📞 Get in Touch 📞
              </h1>
            </div>
            <p className="text-xl text-kala-secondary font-semibold">
              Have questions? Reach out to our coordinators
            </p>
            <div className="h-1 w-24 mx-auto mt-4 rounded-full" style={{
              background: 'linear-gradient(90deg, #2FA8FF, #37E7D9, #FF7B3D)'
            }}></div>
          </div>


          {/* Faculty Coordinators */}
          <div className="mb-16 animate-fade-up" style={{ animationDelay: '0.2s' }}>
            <h2 className="text-3xl font-bold text-kala-primary mb-8 flex items-center gap-3">
              <span className="w-1 h-8 bg-gradient-to-b from-kala-blue to-kala-cyan rounded-full"></span>
              Faculty Coordinators
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {facultyCoordinators.map((coordinator, idx) => (
                <div key={idx} className="card-soft overflow-hidden hover:shadow-soft-lg transition-all duration-300">
                  <div className="relative w-full h-56 bg-gradient-to-br from-kala-blue/10 to-kala-cyan/10 flex items-center justify-center">
                    <img 
                      src={coordinator.image} 
                      alt={coordinator.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-bold text-kala-primary mb-1">{coordinator.name}</h3>
                    <p className="text-sm text-kala-secondary mb-4">{coordinator.dept}</p>
                    <div className="space-y-2">
                      <a
                        href={`tel:${coordinator.phone}`}
                        className="flex items-center gap-2 text-sm text-kala-secondary hover:text-kala-blue transition-colors"
                      >
                        <Phone size={16} />
                        {coordinator.phone}
                      </a>
                      <a
                        href={`mailto:${coordinator.email}`}
                        className="flex items-center gap-2 text-sm text-kala-secondary hover:text-kala-blue transition-colors"
                      >
                        <Mail size={16} />
                        {coordinator.email}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Student Volunteers */}
          <div className="mb-16 animate-fade-up" style={{ animationDelay: '0.3s' }}>
            <h2 className="text-3xl font-bold text-kala-primary mb-8 flex items-center gap-3">
              <span className="w-1 h-8 bg-gradient-to-b from-kala-orange to-kala-yellow rounded-full"></span>
              Student Volunteers
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {studentVolunteers.map((volunteer, idx) => (
                <div key={idx} className="card-soft overflow-hidden hover:shadow-soft-lg transition-all duration-300">
                  <div className="team-card p-6">
                    <div className="flex-1 flex flex-col justify-center">
                      <h3 className="font-bold text-kala-primary mb-2 text-lg">{volunteer.name}</h3>
                      <p className="text-sm text-kala-secondary mb-4">{volunteer.role}</p>
                      <a
                        href={`https://wa.me/91${volunteer.phone.replace(/\D/g, '').slice(-10)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-kala-blue to-kala-cyan text-white text-sm font-medium rounded-lg hover:shadow-soft-lg transition-all duration-300 w-fit"
                      >
                        <MessageCircle size={16} />
                        WhatsApp
                      </a>
                    </div>
                    {volunteer.image ? (
                      <div className="relative w-32 h-64 bg-gradient-to-br from-kala-orange/10 to-kala-yellow/10 flex items-center justify-center rounded-lg flex-shrink-0">
                        <img 
                          src={volunteer.image} 
                          alt={volunteer.name}
                          className="w-full h-full object-contain"
                        />
                      </div>
                    ) : (
                      <div className="w-32 h-64 bg-gradient-to-br from-kala-orange/10 to-kala-yellow/10 flex items-center justify-center rounded-lg flex-shrink-0">
                        <div className="text-6xl">👤</div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* College Address & Map */}
          <div className="animate-fade-up" style={{ animationDelay: '0.4s' }}>
            <h2 className="text-3xl font-bold text-kala-primary mb-8 flex items-center gap-3">
              <span className="w-1 h-8 bg-gradient-to-b from-kala-cyan to-kala-blue rounded-full"></span>
              College Address
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Address Card */}
              <div className="card-soft p-8 flex flex-col items-center justify-center text-center">
                <div className="flex flex-col items-center gap-4 mb-6">
                  <MapPin size={24} className="text-kala-blue flex-shrink-0" />
                  <div>
                    <h3 className="font-bold text-kala-primary mb-2">KLE Society's college of BCA Gokak</h3>
                    <p className="text-kala-secondary text-sm leading-relaxed">
                      Gokak, Karnataka<br />
                      India
                    </p>
                  </div>
                </div>
                <a
                  href="https://maps.google.com/?q=KLE+Society+college+of+BCA+Gokak"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-6 py-2 bg-gradient-to-r from-kala-blue to-kala-cyan text-white font-medium rounded-lg hover:shadow-soft-lg transition-all duration-300"
                >
                  View on Maps
                </a>
              </div>

              {/* Map Embed - OpenStreetMap (No API Key Needed) */}
              <div className="card-soft p-4 overflow-hidden rounded-lg">
                <iframe
                  width="100%"
                  height="300"
                  frameBorder="0"
                  style={{ border: 0, borderRadius: '8px' }}
                  src="https://www.openstreetmap.org/export/embed.html?bbox=74.8200,16.1650,74.8350,16.1750&layer=hot&marker=16.1693821,74.829404"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
